import { YesNoFlag } from '../../shared/types';

export enum EDITABLE_FIELD_CONDITIONS {
  OBLIGATION_NOL_UTILIZE = 'OBLIGATION_NOL_UTILIZE',
  OBLIGATION_NOL_RECORD = 'OBLIGATION_NOL_RECORD',
  OBLIGATION_STATE_PRE_NOL = 'OBLIGATION_STATE_PRE_NOL',
  OBLIGATION_STATE_POST_NOL = 'OBLIGATION_STATE_POST_NOL',
}

export enum HIDDEN_FIELD_CONDITIONS {
  COMPANY_CODE_STAT_CALC_DISABLED = 'COMPANY_CODE_STAT_CALC_DISABLED',
}

export enum OBLIGATION_NOL_VALUES {
  UTILIZE = 'UTILIZE',
  RECORD = 'RECORD',
}

export enum OBLIGATION_STATE_PRE_POST_VALUES {
  PRE = 'PRE',
  POST = 'POST',
}

type CompareFieldPrefixes = 'BASE_' | 'COMPARE_' | 'VARIANCE_';

type NonComparableScenarioReportData = {
  COMPANY_CODE_STAT_CALC: YesNoFlag,
  OBLIGATION_NOL: OBLIGATION_NOL_VALUES,
  OBLIGATION_STATE_PRE_POST_NOL: OBLIGATION_STATE_PRE_POST_VALUES,
  FUNCTIONAL_CURRENCY: string,
}

type ComparableScenarioReportData = {
  GAAP_DEF_TAX: number,
}

export type ScenarioReportData = NonComparableScenarioReportData & ComparableScenarioReportData

export type ScenarioCompareReportData = {
  [Key in keyof ComparableScenarioReportData as `${CompareFieldPrefixes}${Key}`]: ComparableScenarioReportData[Key]
} & NonComparableScenarioReportData;

export type ScenarioReportsData = Record<ReportName, ScenarioReportData[]>;

export type ReportName = string;

